var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideNavOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 23.5,
    fill: "#F5F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 17L20.0943 17M31 24L23.9434 24M31 31L20.0943 31M19.7736 24L16.8868 24L15.6038 24L14 24M14 24L16.2453 21.7727M14 24L16.2453 26.2273",
    stroke: "#343A40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavOpen);
export default __webpack_public_path__ + "static/media/sideNavOpen.235385c441e279c4427cfede0e03c0cc.svg";
export { ForwardRef as ReactComponent };